import { Badge, Box, Card, Flex, Text } from "@radix-ui/themes";
import { getStatusColor } from "./api";
import type { ForkResult } from "./types";

interface SweepCase extends ForkResult {
  params?: Record<string, number>;
}

interface Props {
  cases: SweepCase[];
}

function paramLabel(params: Record<string, number> | undefined): string {
  if (!params) return "";
  return Object.entries(params)
    .map(([k, v]) => {
      const short = k.replace(/_deg$/, "").replace("velocity_magnitude", "V");
      return `${short}=${v}`;
    })
    .join(", ");
}

export function SweepProgress({ cases }: Props) {
  if (!cases.length) return null;

  return (
    <Box mt="3">
      <Text size="2" weight="medium" mb="2" as="p">
        Submitted Cases ({cases.length})
      </Text>
      <Flex direction="column" gap="2">
        {cases.map((c) => (
          <Card key={c.flow360_case_id || c.case_name} size="1">
            <Flex justify="between" align="center">
              <Flex direction="column" gap="1">
                <Text size="2" weight="medium">
                  {c.case_name}
                </Text>
                {c.params && (
                  <Text size="1" color="gray">
                    {paramLabel(c.params)}
                  </Text>
                )}
              </Flex>
              <Badge
                color={getStatusColor(c.status) as "gray"}
                variant="soft"
              >
                {c.status}
              </Badge>
            </Flex>
          </Card>
        ))}
      </Flex>
    </Box>
  );
}
